<div class="avatar">
    <div class="img">
        <img [style.Width]="width" [style.Height]="width" src="{{this.avatar}}" onError="this.src ='../../../assets/images/user.png'"
        (click)="photoUpload.click()" *ngIf="type!=='icon'"/>
        <img [style.Width]="width" [style.Height]="width" src="{{this.avatar}}" onError="this.src ='/assets/images/defaultIcon.png'"
        (click)="photoUpload.click()" *ngIf="type=='icon'"/>
    </div>
    <input hidden type="file" #photoUpload (change)="uploadFile($event)" />
</div>